import React from 'react';
import 'antd-mobile/dist/antd-mobile.css';
// import Background from './../../images/bg.jpg'
import logo from "./../../images/logo.png"
import { Button } from 'antd-mobile';

const style = {
    bgd: {
        // color: 'rgba(0,0,0,.25)'
        // backgroundImage: `url(${Background}) `,
        backgroundSize: '100%,100%',
        // backgroundColor:'rgba(0,0,0,.25)',
        textAlign: 'center',
        // height:'100%'
    },
    text: {
        padding: '50px 50px'
    },
    img: {
        width: '160px',
        height: '40px'

    },
    btn: {
        borderRadius: '30px',
    }
}

class Download extends React.Component {
    handleClick = () => {
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android
        if (isiOS) {
            alert('isiOS')
            window.location.href = ''
        } else if (isAndroid) {
            var b = navigator.language;
            if (b == "zh-CN") {
                alert('ch')
                window.location.href = ''
            } else {
                alert('en')
                window.location.href = ''
            }
        } else {
            alert('gg')
        }
    }


    render() {
        return (
            <div style={style.bgd}>
                <p style={style.text}>若已安装neabot app，<br></br>点击右上角...，选择在浏览器中打开</p>
                <div style={style.text}><img src={logo} style={style.img} alt=''></img></div>
                <Button type="primary" inline style={style.btn} onClick={this.handleClick}>立即下载</Button>
            </div>
        );
    }
}

export default Download